import { NoMetaMaskError } from '@web3-react/metamask'

export class UnsupportedChainIdError extends Error {
  constructor(chainId: number) {
    super(`Unsupported chain id ${chainId}`)
    this.name = UnsupportedChainIdError.name
    Object.setPrototypeOf(this, UnsupportedChainIdError.prototype)
  }
}

// EIP-1193 provider error codes
const USER_REJECTED_REQUEST = 4001
const REQUEST_ALREADY_PENDING = -32002

export const getErrorMessage = (error: Error & { code?: number }) => {
  if (error instanceof NoMetaMaskError) {
    return 'No Ethereum browser extension detected, install MetaMask on desktop or visit from a dApp browser on mobile.'
  } else if (error instanceof UnsupportedChainIdError) {
    return "You're connected to an unsupported network."
  } else if (error.code === USER_REJECTED_REQUEST) {
    return 'Please authorize this website to access your Ethereum account.'
  } else if (error.code === REQUEST_ALREADY_PENDING) {
    return 'A connection request is already pending, open MetaMask to continue.'
  } else {
    console.error(error)
    return 'An unknown error occurred. Check the console for more details.'
  }
}

export class UndefinedDataError extends Error {
  message = 'Data is undefined'
}

export const throwIfUndefined = <T>(data: T | null | undefined): T => {
  if (data === undefined || data === null) {
    throw new UndefinedDataError()
  }
  return data
}
